import React, { Component } from 'react';
import bus from './bus';
import Ajax from './ajax';

class Manager extends Component {
    constructor(props) {
        super(props);
        this.state = { authorizations: [] };
        this.getAuthorization = this.getAuthorization.bind(this);
    }

    componentDidMount() {
        Ajax.post('manager', {}, function (response) {
            this.listRef.style.display = 'block';
            this.toastRef.style.display = 'none';
            if (response.result) {
                this.setState({ authorizations: response.data });
            }
        }.bind(this));
    }

    editAuthorization(event) {
        bus.emit('edit', event.currentTarget.id);
    }

    getAuthorization(auth) {
        return (
            <a id={auth.id} className="weui-cell weui-cell_access" onClick={this.editAuthorization}>
                <div className="weui-cell__bd">{auth.name}</div>
                <div className="weui-cell__ft">{auth.desc}</div>
            </a>
        );
    }

    render() {
        let list = this.state.authorizations.map(this.getAuthorization);
        return (
            <div className="flex-page">
                <div className="weui-cells__title">授权列表</div>
                <div className="weui-cells grow scroll" ref={listRef => this.listRef = listRef}>{list}</div>
                <div className="grow" ref={toastRef => this.toastRef = toastRef}>
                    <div className="weui-mask_transparent"></div>
                    <div className="weui-toast">
                        <i className="weui-loading weui-icon_toast"></i>
                        <p className="weui-toast__content">数据加载中</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Manager;



// WEBPACK FOOTER //
// ./src/manager.js